import Point from '../../Utility/Point';
import Element from './Element';
import GameObject from '../../GameObject/GameObject';
import UINineSliceComponent from '../../Component/UI/NineSlice';

export default class TodoItem extends Element {
    public create(params: any): void {
        super.create({
            type: 'group',
            name: 'todo_item',
            layout: {
                anchors: [0, 0, 1, 0],
                offsets: [0, 0, 0, 0],
                pivot: [0.5, 0],
                constrains: {
                    heightMin: 133,
                    heightMax: 133,
                    widthMin: 458,
                    widthMax: 458,
                },
            },
            components: [
                {
                    type: 'nineslice',
                    data: {
                        cacheKey: 'rounded_rectangle1_9_slice',
                        offset: [15, 15, 15, 15],
                    },
                },
            ],
        });

        // Title.
        const title: Element = GameObject.Instantiate(Element, {
            type: 'group',
            name: 'title',
            layout: {
                anchors: [0.5, 0, 0.5, 0],
                pivot: [0.5, 0],
                offsets: [0, -10, 0, -10],
            },
            components: [
                {
                    type: 'text',
                    data: {
                        textLocalizationKey: params.title || '',
                        style: {
                            font: 'RussoOne',
                            fill: '#4A2317',
                            fontSize: '22px',
                        },
                        align: 'center',
                        bounds: [420, 50],
                        wordWrap: true,
                        wordWrapWidth: 420,
                    },
                },
            ],
        });
        this.addChild(title);

        // Progress bar.
        const progress: Element = GameObject.Instantiate(Element, {
            type: 'group',
            name: 'progress',
            layout: {
                anchors: [0.5, 0.5, 0.5, 0.5],
                pivot: [0.5, 0.5],
                offsets: [0, 0, 0, 0],
            },
            components: [
                {
                    type: 'image',
                    data: {
                        cacheKey: 'mission_line_back',
                    },
                },
            ],
        });
        this.addChild(progress);

        const bar: Element = GameObject.Instantiate(Element, {
            type: 'group',
            name: 'bar',
            layout: {
                anchors: [0, 0.5, 0, 0.5],
                pivot: [0, 0.5],
                offsets: [0, 0, 0, 0],
                scale: [params.progress || 1, 1],
            },
            components: [
                {
                    type: 'image',
                    data: {
                        cacheKey: 'mission_line',
                    },
                },
            ],
        });
        progress.addChild(bar);

        // Icon.
        const icon: Element = GameObject.Instantiate(Element, {
            type: 'group',
            name: 'icon',
            layout: {
                anchors: [0.1, 0.5, 0.1, 0.5],
                pivot: [0.5, 0.5],
                offsets: [0, 0, 0, 0],
            },
            components: [
                {
                    type: 'image',
                    data: {
                        cacheKey: params.icon || 'missions_icon1',
                    },
                },
            ],
        });
        this.addChild(icon);

        // Reward icon.
        const rewardIcon: Element = GameObject.Instantiate(Element, {
            type: 'group',
            name: 'rewardIcon',
            layout: {
                anchors: [0, 1, 0, 1],
                pivot: [0, 1],
                offsets: [-5, 5, -5, 5],
            },
            components: [
                {
                    type: 'image',
                    data: {
                        cacheKey: params.rewardIcon || 'key_mission',
                    },
                },
            ],
        });
        this.addChild(rewardIcon);

        // Reward text.
        const rewardText: Element = GameObject.Instantiate(Element, {
            type: 'group',
            name: 'rewardDesc',
            layout: {
                anchors: [0, 1, 0, 1],
                pivot: [0, 1],
                offsets: [-75, 6, -75, 6],
            },
            components: [
                {
                    type: 'text',
                    data: {
                        textLocalizationKey: params.rewardDesc || '',
                        style: {
                            font: 'RussoOne',
                            fill: '#4A2317',
                            fontSize: '22px',
                        },
                        align: 'left',
                    },
                },
            ],
        });
        this.addChild(rewardText);

        const buttonComplete = this.getButton({
            name: 'buttonComplete',
            hidden: params.progress < 1 || true,
            cacheKey: 'button_green',
            textLocalizationKey: 'Complete',
        });

        this.addChild(buttonComplete);

        const buttonSkip = this.getButton({
            name: 'buttonSkip',
            hidden: true,
            cacheKey: 'button_blue',
            textLocalizationKey: 'Skip',
            icon: 'ad_icon',
            textAnchor: [0, 0, 1, 1],
            textOffset: [-20, 5, 0, 5],
        });

        this.addChild(buttonSkip);

        // Waiting a new mission.
        const waitNewMission: Element = GameObject.Instantiate(Element, {
            type: 'group',
            name: 'wait',
            layout: {
                anchors: [0.5, 0.3, 0.5, 0.3],
                pivot: [0.5, 0.5],
                offsets: [0, 0, 0, 0],
            },
            components: [
                {
                    type: 'text',
                    data: {
                        textLocalizationKey: 'WaitingNewMission',
                        style: {
                            font: 'RussoOne',
                            fill: '#4A2317',
                            fontSize: '28px',
                        },
                        align: 'center',
                        bounds: [420, 50],
                        wordWrap: true,
                        wordWrapWidth: 420,
                    },
                },
                {
                    type: 'visibility',
                    data: {
                        hidden: true,
                    },
                },
            ],
        });
        this.addChild(waitNewMission);

        const timer: Element = GameObject.Instantiate(Element, {
            type: 'group',
            name: 'timer',
            layout: {
                anchors: [0.5, 0.7, 0.5, 0.7],
                pivot: [0.5, 0.5],
                offsets: [0, 0, 0, 0],
            },
            components: [
                {
                    type: 'text',
                    data: {
                        textLocalizationKey: '00:00:00',
                        style: {
                            font: 'RussoOne',
                            fill: '#fff',
                            fontSize: '36px',
                        },
                        align: 'center',
                    },
                },
                {
                    type: 'visibility',
                    data: {
                        hidden: true,
                    },
                },
            ],
        });
        this.addChild(timer);
    }

    protected onCreate(params: any): void {
        super.onCreate(params);

        this.getComponent(UINineSliceComponent).tint = 0xffb16f;
    }

    private getButton(params: {
        name: string;
        hidden: boolean;
        cacheKey: string;
        textLocalizationKey: string;
        icon?: string;
        textOffset?: [number, number, number, number];
        textAnchor?: [number, number, number, number];
    }): Element {
        params = {
            textOffset: [0, 0, 0, 0],
            textAnchor: [0, 0, 1, 1],
            ...params,
        };

        const button = GameObject.Instantiate(Element, {
            type: 'group',
            name: params.name,
            layout: {
                anchors: [0.85, 1, 0.85, 1],
                pivot: [0.5, 0.5],
                offsets: [20, 10, 20, 10],
                scale: [0.6, 0.6],
            },
            components: [
                {
                    type: 'image',
                    data: {
                        cacheKey: params.cacheKey,
                    },
                },
                {
                    type: 'input',
                    data: {
                        enabled: true,
                    },
                },
                {
                    type: 'visibility',
                    data: {
                        hidden: params.hidden,
                    },
                },
            ],
        });

        const buttonText = GameObject.Instantiate(Element, {
            type: 'group',
            name: 'buttonCompleteText',
            layout: {
                anchors: params.textAnchor,
                pivot: [0.5, 0.5],
                offsets: params.textOffset,
            },
            components: [
                {
                    type: 'text',
                    data: {
                        textLocalizationKey: params.textLocalizationKey,
                        style: {
                            font: 'RussoOne',
                            fill: '#fff',
                            fontSize: '34px',
                        },
                        align: 'center',
                        bounds: params.icon ? [180, 100] : [240, 100],
                    },
                },
            ],
        });

        button.addChild(buttonText);

        if (params.icon) {
            const icon = GameObject.Instantiate(Element, {
                type: 'image',
                name: 'buttonIcon',
                layout: {
                    anchors: [0, 0.5, 0, 0.5],
                    pivot: [0.5, 0.5],
                    offsets: [-70, 5, -70, 5],
                    scale: [0.8, 0.8],
                },
                components: [
                    {
                        type: 'image',
                        data: {
                            cacheKey: params.icon,
                        },
                    },
                ],
            });

            button.addChild(icon);
        }

        return button;
    }
}
